import { Helmet } from "react-helmet-async";
import { Container } from "@mui/material";
import { Routes, Route } from "react-router-dom";

import MemberMenu from "../sections/@dashboard/members/MemberMenu";
import MemberView from "../sections/@dashboard/members/MemberView";
import SelfRegistrationsView from "../sections/@dashboard/members/SelfRegistrationsView";
import AttendanceLandingView from "../sections/@dashboard/members/attendance/AttendanceLandingView";
import TrainingAttendanceDetailView from "../sections/@dashboard/members/attendance/TrainingAttendanceDetailView";
import FeatureGateRoute from "../components/plan/FeatureGateRoute";
import { FEATURE_KEYS } from "../utils/planFeatures";

// ----------------------------------------------------------------------

export default function MembersPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Mitglieder </title>
      </Helmet>

      <Container maxWidth="">
        <Routes>
          {/* Default landing for /members */}
          <Route index element={<MemberMenu />} />

          {/* Members overview table */}
          <Route path="overview" element={<MemberView />} />
          <Route
            path="self-registrations"
            element={
              <FeatureGateRoute
                featureKey={FEATURE_KEYS.PUBLIC_REGISTRATION}
                fallbackPath="/dashboard/members"
              >
                <SelfRegistrationsView />
              </FeatureGateRoute>
            }
          />
          <Route
            path="attendance"
            element={
              <FeatureGateRoute
                featureKey={FEATURE_KEYS.TRAINING_ATTENDANCE}
                fallbackPath="/dashboard/members"
              >
                <AttendanceLandingView />
              </FeatureGateRoute>
            }
          />
          <Route
            path="attendance/:trainingId"
            element={
              <FeatureGateRoute
                featureKey={FEATURE_KEYS.TRAINING_ATTENDANCE}
                fallbackPath="/dashboard/members"
              >
                <TrainingAttendanceDetailView />
              </FeatureGateRoute>
            }
          />

          {/* (Optional) future nested routes:
              <Route path="create" element={<CreateMemberView />} />
              <Route path="import" element={<ImportMembersView />} />
              <Route path=":memberId" element={<SingleMemberView />} />
          */}
        </Routes>
      </Container>
    </>
  );
}
